export default {
  install: (app, options) => {
    const formatAppointmentDate = (originalDate) => {
      const date = new Date(originalDate);
      const options = {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };

      return date.toLocaleString(
        app.config.globalProperties.$i18n.locale,
        options
      );
    };

    app.config.globalProperties.$appointmentManager = {
      formatAppointmentDate,
    };
  },
};
